import { EventEmitter, Injectable, Output } from '@angular/core';
import { ApiUrlConstant } from '@app-constants/api-url.constant';
import { RestApiService } from '@app-services/rest/rest-api.service';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { TenantConstant } from '@app-constants/tenant.constant';
import { HttpClient } from '@angular/common/http';
import { LoginService } from '@app-services/login/login.service';
import { LocalStorageService } from 'ngx-webstorage';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { allSubjectsInOrder, neetNewVerTypes, questionTypes } from '@app-constants/app.constants';
import { filterCMSData, getExamName } from '@app-helpers/functions';
import { TestlistService } from './testlist.service';
import { ClassService } from 'src/app/core/services/class.service';
import { apisDataCacheKeys } from "@app-constants/app.constants";
import { stringify } from 'querystring';

const subIndices = {
  'CHEMISTRY': 0,                      
  'PHYSICS': 1,
  'MATHEMATICS': 2,
  'BOTANY': 2,
  'BIOLOGY': 2,
  'ZOOLOGY': 3,
  'MAT': 4
};

@Injectable({
  providedIn: 'root'
})
export class ExamService extends RestApiService{
  tenant: any = TenantConstant.tenant;
  apiUrl = ApiUrlConstant.examUrl;
  cmsapiUrl = ApiUrlConstant.cmsrUrl;
  examinfo: any;
  examdetails: any;
  constructor(http: HttpClient, storage: LocalStorageService, gaService: GAnalyticsService, private loginService: LoginService,private _httpClient:HttpClient,private testlistService :TestlistService,  private classService: ClassService,) { super(http, storage, gaService); }
  @Output() getExamInfo: EventEmitter<any> = new EventEmitter();
  @Output() submitExamFromHeader: EventEmitter<any> = new EventEmitter();
  @Output() showQuestionByNumber: EventEmitter<any> = new EventEmitter();
  @Output() showReportQuestionByNumber: EventEmitter<any> = new EventEmitter();
  @Output() testBegins: EventEmitter<any> = new EventEmitter();
  @Output() testFinish: EventEmitter<any> = new EventEmitter();
  @Output() subjectChange: EventEmitter<any> = new EventEmitter();
  @Output() subjectChangeSolutionPage: EventEmitter<any> = new EventEmitter();
  private examMetaDataSource = new BehaviorSubject<any>(null);
  examMetaData = this.examMetaDataSource.asObservable();
  examInfo: any = null;
  examData: any = null;
  rules: any = null;
  questionsData: any = null;
  newQuestions: any = null;
  subName: any;
  autoSubmitExam :boolean = false;
  public submitFeedbackPopupSubject = new BehaviorSubject<any>(false);
  public heavy_storage_reponse:any ={}
  submitFeedbackPopupSubject$ = this.submitFeedbackPopupSubject.asObservable();
  multiSubscriber = () => {
    let observers: any = [];
    return (observer: any) => { 
      observers.push(observer);
      if (observers.length === 1) {
        if(this.questionsData && this.newQuestions) {
          observers.forEach((o: any) => {
            o.next(true);
            o.complete();
          })
          observers = []; //not a good practice, but for ease of use, avoiding call to unsubscribe and doing this
        }  else {
          const data = this.getPresentExamInfo();
          const detail = JSON.parse(localStorage.getItem('mobile_and_name') as string) || {}
          const postdata = {
            scheduleid: data.scheduleid,
            ruleid: data?.testrule_id||data?._id,
            clearcache: true,
            studentid: localStorage.getItem('studentid'),
            attempt: data?.attempt||'1'
          }
          this.setNewQuestions([]);
          this.postNode('exam/questions', postdata).subscribe(
            async (resdata1: any) => {
              data.consolidateSubject = resdata1?.consolidateSubject;
              data.sectionExists = resdata1?.sectionsExist;
              this.setPresentExamInfo(data);
              data.attempt = data?.attempt? data?.attempt:'1'
              this.storage.store('examinfo',data)
              if (resdata1.questions) {
                
                this.setExamRules(data);
                let examName = localStorage.getItem("targetExamName") as string;
                if(!examName) {
                  observers.forEach((o: any) => {
                    o.next(false);
                    o.complete();
                  })
                  observers = []; //not a good practice, but for ease of use avoiding call to unsubscribe and doing this
                  alert("Server error");
                  return;
                }
                let sectionsExist = false;
                let questions_: any = [];
                let questionsBySubName = {};
                let subjectModifiedName = {}
                const questionsObjArr = resdata1?.questions?.subjects?.length > 0 ? resdata1?.questions?.subjects : resdata1?.questions?.sections;
                if(
                  (data.examtype || "") == "SCHOLARSHIPTEST" ||
                  examName == 'SCORE' || examName == 'SCAT' || examName == 'JEEADVANCED' || examName == 'JEEMAIN' || data.examtype=='RAPTimeBound'|| data.examtype== 'b9f32e18-34e8-11ed-a261-0242ac120002'||
                  (examName == "NEET" && neetNewVerTypes.indexOf(data.examtype || "") > -1)
                ) {
                  if(data.sectionExists) {
                    sectionsExist = true;  
                    // questionsObjArr.sort((a, b) => {
                    //   const subjectName1 = (a.subjectname || "").replaceAll(" ", "").toUpperCase();
                    //   const subjectName2 = (b.subjectname || "").replaceAll(" ", "").toUpperCase();
                    //     return subjectName1 < subjectName2 ? -1 : subjectName1 > subjectName2 ? 1 : 0;
                    // });
                  }
                }
                if((Array.isArray(questionsObjArr) && questionsObjArr.length)) 
                {   
                  let subIndex = 0;
                  for(let i = 0, len = questionsObjArr.length; i<len; i++ )   
                  {
                    const question_ = questionsObjArr[i];
                    const subjectName = (question_.subjectname || "").replaceAll(" ", "").toUpperCase();
                    let displayedSubName = subjectName;
                    if(/^CHEMISTRY/i.test(subjectName)){
                      displayedSubName = 'CHEMISTRY';
                    } else if(/^PHYSICS/i.test(subjectName)){
                      displayedSubName = 'PHYSICS';
                    } else {
                      if(/^MATHEMATICS/i.test(subjectName) || /^MATHS/i.test(subjectName)){
                        displayedSubName = 'MATHEMATICS'
                      } else if(/^MAT\s+/i.test(question_.subjectname)){
                        //For MAT, compare regEx with original subject name to avoid conflicts with variants of Maths name
                        displayedSubName = 'MAT'
                      } else if(/^BIOLOGY/i.test(subjectName)){
                        displayedSubName = 'BIOLOGY';
                      } else if(/^BRAINTEASERS/i.test(subjectName)){
                        displayedSubName = 'BRAINTEASERS';
                      } else if(/^GENERALSCIENCE/i.test(subjectName)){
                        displayedSubName = 'SCIENCE';
                      }else if(/^ENGLISHV1/i.test(subjectName)){
                        displayedSubName = 'ENGLISH';
                      }
                       else {
                        if(/^BOTANY/i.test(subjectName)){
                          displayedSubName = 'BOTANY'
                        } else if(/^ZOOLOGY/i.test(subjectName)) {
                          displayedSubName = 'ZOOLOGY'
                        }
                        // if(data.examtype != 'SCHOLARSHIPTEST' && data.examtype != "RAPTimeBound") {
                        //   if(neetNewVerTypes.indexOf(data.examtype || "") > -1) {
                        //     if(!sectionsExist) {
                        //       displayedSubName = 'BIOLOGY';
                        //     }
                        //   } 
                        //   else {
                        //     if((/^BOTANY/i.test(subjectName) || /^ZOOLOGY/i.test(subjectName)) && data.examtype == 'ASSIGNMENTS'){
                        //       displayedSubName = 'BIOLOGY'
                        //     }
                        //   }
                        // }
                      }
                    }
                    if(displayedSubName) {
                      subIndices[displayedSubName] = ++subIndex;
                      // = subIndices[displayedSubName]
                      if(!questionsBySubName[displayedSubName]) {
                        questionsBySubName[displayedSubName] = {

                        };
                      }
                      let questions = question_.questions || [];
                      if(sectionsExist) {
                      {
                          const sections = {};
                          for(let j = 0, len = questions.length; j < len; j++) {
                            let q = questions[j];
                            q.subjectname = displayedSubName;
                            q.subgradeName = subjectName;
                            if(!sections[q.section]) {
                              sections[q.section] = [];
                            }
                            sections[q.section].push(q);  
                          }
                          
                          Object.keys(sections).forEach(e => {
                            if(!questionsBySubName[displayedSubName][e]) {
                              questionsBySubName[displayedSubName][e] = [];
                            }
                            Array.prototype.push.apply(questionsBySubName[displayedSubName][e], sections[e]);
                          })
                        }
                      } else {
                        let questions1 = [], questions2 = [], qInd = questions.length;
                        
                        if(examName !== "JEEMAIN" && examName !== "SCORE" && examName !== 'SCAT') { 
                          //if(examName !== "JEEADVANCED") { 
                            if(neetNewVerTypes.indexOf(data.examtype || "") > -1) {
                              if(subjectName === `${displayedSubName}XI`) {
                                qInd = 17;
                              } else {
                                qInd = 18;
                              }
                            }
                            questions1 = setSubjectName(questions.slice(0, qInd), displayedSubName, subjectName);
                            questions2 = setSubjectName(questions.slice(qInd), displayedSubName, subjectName);  
                            
                            const sections = {"Sec A": questions1, "Sec B": questions2};
                            
                              if(!questionsBySubName[displayedSubName]["Sec A"]) {
                                questionsBySubName[displayedSubName]["Sec A"] = [];
                              }
                              if(!questionsBySubName[displayedSubName]["Sec B"]) {
                                questionsBySubName[displayedSubName]["Sec B"] = [];
                              }
                              if(neetNewVerTypes.indexOf(data.examtype || "") > -1) {
                                Array.prototype.unshift.apply(questionsBySubName[displayedSubName]["Sec A"], sections["Sec A"]);
                              } else {
                                Array.prototype.push.apply(questionsBySubName[displayedSubName]["Sec A"], sections["Sec A"]);
                              }
                              
                              Array.prototype.push.apply(questionsBySubName[displayedSubName]["Sec B"], sections["Sec B"]);
                          //}
                        } else {
                          (questions || []).forEach((q: any) => {
                            q.subjectname = displayedSubName;
                            q.subgradeName = subjectName;
                            if(q.questiontype == "ec2f3aec-e64c-11ec-8fea-0242ac120002") {
                              questions2.push(q);
                            } else {
                              questions1.push(q);
                            }
                          });
                          const sections = {"Sec A": questions1, "Sec B": questions2};
                          
                          Object.keys(sections).forEach(e => {
                            if(!questionsBySubName[displayedSubName][e]) {
                              questionsBySubName[displayedSubName][e] = [];
                            }
                            Array.prototype.push.apply(questionsBySubName[displayedSubName][e], sections[e]);
                          })
                        }
                      }
                    }
                    subjectModifiedName[displayedSubName?.toLowerCase()] = subjectName?.toLowerCase()
                  }
                }
                
                const emd = JSON.parse(localStorage.getItem('exam_meta_data')) || {};
                const sections = {};
                allSubjectsInOrder.forEach(element => {
                  if(questionsBySubName[element]) {
                    const subIndex = subIndices[element];
                    if(!questions_[subIndex]){
                      const q: any = {}
                      q.subjectname = element;
                      questions_[subIndex] = { ...q, questions: []};
                    }
                    sections[element] = [];
                    let questioncounter = 0;
                    Object.keys(questionsBySubName[element]).sort().forEach((e, i) => {
                      questions_[subIndex].questions = questions_[subIndex].questions.concat(questionsBySubName[element][e]);
                      sections[element].push({
                        name: e,//i+1,
                        count: questionsBySubName[element][e].length,
                        questioncounter
                      })
                      questioncounter += questionsBySubName[element][e].length;
                    })
                  }
                });
                if(resdata1?.sectionsInPapers =="Section above subject"){
                  questionsObjArr?.forEach((v=>{
                    v.subjectname = v?.section
                    if(!v?.subject){
                      v.subject = v?.subjectList;
                    }
                    if(!sections[v?.section]){
                      sections[v?.section]=[]
                    }
                    sections[v?.section] = [...v?.subject]
                    
                    if(data?.examtype=="subjectivemocktest"){
                      sections[v?.section]=[{
                          count: v?.questions?.length,
                          name: v?.section,
                          questioncounter:0
                        }]
                    }
                  }))
                  questions_ = questionsObjArr
                }
                if (sectionsExist || resdata1?.sectionsExist) {
                  emd.sections = sections;
                  //resdata1?.consolidateSubject
                  const isNeet = ['51592ef8-8334-479f-8a91-7cfe809b7c04', '5d6fcff0-1000-45bb-b62a-d3d2b2bd3189'].some(v => v == data?.test_type)//(courseType || "").replaceAll(" ", "").toUpperCase() == 'NEET';
                  if (this.checkIsSubjectConsidate()) {
                    Object.keys(sections)?.forEach(element => {
                      if (element == 'BOTANY' || element == 'ZOOLOGY') {
                        if (sections['BIOLOGY']) {
                          sections[element].forEach((vin) => {
                            let findIndex = sections['BIOLOGY']?.findIndex(vI => vI?.name == vin?.name)
                            if (findIndex > -1) {
                              sections['BIOLOGY'][findIndex].count = sections['BIOLOGY'][findIndex].count + vin.count
                              sections['BIOLOGY'][findIndex].questioncounter = sections['BIOLOGY'][findIndex].questioncounter + vin.questioncounter
                            }
                          })
                        } else {
                          const arr = JSON.stringify(sections[element])
                          sections['BIOLOGY'] = JSON.parse(arr)
                        }
                      }
                    });
                  }
                  this.updatedExamMetaDataSource(emd);
                }
                questions_.forEach(element => {
                  for(let i = 0, len = questionsObjArr.length; i<len; i++ )   
                  {
                    const questData = questionsObjArr[i];
                    const subjectName = (questData.subjectname || "").replaceAll(" ", "").toUpperCase();
                    if(element.subjectname == subjectName){
                      element.subject = questData.subject.toString();
                    }
                  }
               });
               questions_.forEach(v=>{
                if(!v?.subject){
                let findInOldQe = questionsObjArr.find(queObj=>queObj?.subjectname?.toLowerCase() == subjectModifiedName[v?.subjectname?.toLowerCase()])
                v.subject = findInOldQe?.subject
                }
               })
               questions_ =   questions_?.filter(v=>v) 
              //  this.storage.store("quesResponses", questions_);
              this.store_max_limit_webstorage("quesResponses",questions_)
                resdata1.questions.subjects = questions_;
                this.setQuestionsData(resdata1.questions);
                let  newQueFormat= resdata1?.questions?.subjects.map((e)=>{
                 return {
                subjectname: e?.subjectname,
                 questions: e?.questions,
                 subjectId: e?.subject
                }
                })
                // const isNeet = ['51592ef8-8334-479f-8a91-7cfe809b7c04', '5d6fcff0-1000-45bb-b62a-d3d2b2bd3189'].some(v => v == data?.test_type)//(courseType || "").replaceAll(" ", "").toUpperCase() == 'NEET';
                if(this.checkIsSubjectConsidate()){
                  let ques = newQueFormat?.filter((e, i, self)=>(e.subjectname == 'BOTANY' || e.subjectname == 'ZOOLOGY'))?.map(v=>v.questions)?.flat();
                  newQueFormat.forEach((e,i,self)=>{
                    if((e.subjectname == 'BOTANY' || e.subjectname == 'ZOOLOGY')&& !self.find(vl=>vl.subjectname == 'BIOLOGY')){
                      e.subjectname ='BIOLOGY'
                      e.questions = ques
                    }
                  })
                  newQueFormat = newQueFormat.filter((e,i)=>!(e.subjectname == 'BOTANY' || e.subjectname == 'ZOOLOGY'));
                }                  
                this.setNewQuestions(newQueFormat)
                for(let i = observers.length - 1; i > -1; i--) {
                  if(observers[i]) {
                    observers[i].next(true);
                    observers[i].complete();
                  }
                }
                observers = []; //not a good practice, but for ease of use avoiding call to unsubscribe and doing this
                resdata1.responses = resdata1.questions;
              } else {
                observers.forEach((o: any) => {
                  o.next(false);
                  o.complete();
                })
                observers = []; //not a good practice, but for ease of use avoiding call to unsubscribe and doing this
              }
            },
            async (err: any) => { 
              observers.forEach((o: any) => {
                o.next(false);
                o.complete();
              })
              observers = []; //not a good practice, but for ease of use avoiding call to unsubscribe and doing this
              if(err?.error?.message?.replaceAll(" ", "")?.toUpperCase().indexOf("ACCESSTOKENEXPIRED") > -1 || err?.error?.message?.replaceAll(" ", "")?.toUpperCase().indexOf("INVALIDTOKEN") > -1 ) {
                this.loginService.logoutEvent.emit({showPopup: true});
              }
            },
          )
        }
      }      
      return {unsubscribe() {
        //observers.splice(observers.indexOf(observer), 1);
      }};
    }
    
  }

  reviewQuestionsObs: any;
  
  reviewQuestions(): Observable<any> {
    if(!this.reviewQuestionsObs) {
      this.reviewQuestionsObs = new Observable(this.multiSubscriber());
    }
    return this.reviewQuestionsObs;
  }

  updatedExamMetaDataSource(data: any){
    localStorage.setItem('exam_meta_data', JSON.stringify(data));
    this.examMetaDataSource.next(data);
  }
  
  submitExam(body_: any, _headers: any): Observable<any>{
    //const url = this.apiUrl + `validatestudenttoken`;
    const url = this.apiUrl + `exam/submitExam`;
    return this.getByHeaders<any>(url, body_, _headers);
  }

  getAvgAndCutOffScore(data:any,token:any): Observable<any> {
    const url = this.apiUrl + `reports/examaverageandcutoffscore`;
    
    let headers = {
      'accesstoken': localStorage.getItem('token')
    };
    return this.getByHeaders<any>(url, data, headers);
  }

  getExamId(): Observable<any>{
    const url = this.apiUrl + `getnextsequence`;
    const token: any = localStorage.getItem('token');
    let headers = {
      'accesstoken': localStorage.getItem('token')
    };
    
    return this.getWithHeaders(url, headers);
  }

  postNode(url: any, payload: any): Observable<any> {
    const url_ = this.apiUrl + `${url}`;
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };

    return this.getByHeaders<any>(url_, payload, headers);
  }

  getByHeader(url: string, body: any, header_: any): Observable<any> {
    return this.getByHeaders<any>(url, body, header_);
  }

  getInstructions(ruleid){
    
    const url_ = this.apiUrl + 'exam/examInstructions';
    let headers = {
      'accesstoken': localStorage.getItem('token'),
    };

    return this.getByHeaders<any>(url_, {ruleid}, headers);
  }
  get(url: string): Observable<any> {
    const headers = new Headers();
    // headers.append('Content-Type', 'application/json');
    // headers.append('Authorization', 'Bearer ' + this.token);

    // headers.append('Strict-Transport-Security', 'maxage=31536000');
    headers.append('X-Content-Type-Options', 'nosniff');
    headers.append('X-Frame-Options', 'SAMEORIGIN');

    return this.getByHeaders<any>(url, {}, headers);

  }

  post(url: string, payload: any): Observable<any> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    // headers.append('Authorization', 'Bearer ' + this.token);
    // headers.append('Strict-Transport-Security', 'maxage=31536000');
    headers.append('X-Content-Type-Options', 'nosniff');
    headers.append('X-Frame-Options', 'SAMEORIGIN');
    return this.getByHeaders<any>(url, payload, headers);
  }

  setNewQuestions(data: any): void {
    this.newQuestions = data;
  }

  setExamRules(rules: any): void {
    this.rules = rules;
  }

  setQuestionsData(data: any): void {
    this.questionsData = data;
  }

  getNewQuestions(): any {
    return this.newQuestions || [];
  }

  getExamRules(): any {
    return this.rules;
  }

  getQuestionsData(): any {
    return this.questionsData;
  }
  
  setPresentExamInfo(exam:any): void {
    this.examinfo = exam;
    this.getExamInfo.emit(exam);
    this.storage.store('examinfo', exam);
    //
  }

  getPresentExamInfo(): any {
    let examinfo = this.storage.retrieve('examinfo');
    return examinfo;
  }

  triggerSubmitExam(): any {
    let examInfo = this.getPresentExamInfo();
    let examname = getExamName(examInfo.test_type[0]) as any;
    let examType = (examname || "").replaceAll(" ", "").toUpperCase();
    if(examType == "MOCKTEST"|| examType == 'New NEET Mock Test') {
      examType = "MCT";
    } else if(examType == 'TIMEBOUND'){
      examType =  this.tenant=='srichaitanya' ? "SCTS": "ILTS";
    } else if(examType == 'New NEET Timebound')
    {
      examType = this.tenant=='srichaitanya' ? "SCTS_new_pattern": "ILTS_new_pattern"; 
    }
    // else if(examType == 'GRANDTEST')
    // {
    //   examType = this.tenant=='srichaitanya' ? "SCTS_new_pattern": "ILTS_new_pattern"; 
    // }
    // else if(examType == 'SCHOLARSHIPTEST')
    // {
    //   examType = this.tenant=='srichaitanya' ? "SCTS_new_pattern": "ILTS_new_pattern"; 
    // }
    else {
      examType = "PYP"
    } 
    this.gaService.sendEvent(
      `submit_exam_${examType}`, 
      examname,
      'submit_exam',
      'submission', 
    );
    this.submitExamFromHeader.emit(null);
  }

  stopSubmitExamFromHeaderEvent() {
    this.submitExamFromHeader.complete();
  }

  triggerTestBegins(): any {
    let examInfo = this.getPresentExamInfo();
    let examType = (examInfo?.examtype || "").replaceAll(" ", "").toUpperCase();
    if(examType == "MOCKTEST"|| examType == 'New NEET Mock Test') {
      examType = "MCT";
    } else if(examType == 'TIMEBOUND'){
      examType =  this.tenant=='srichaitanya' ? "SCTS": "ILTS";
    } else if(examType == 'New NEET Timebound')
    {
      examType = this.tenant=='srichaitanya' ? "SCTS_new_pattern": "ILTS_new_pattern"; 
    }
    // else if(examType == 'GRANDTEST')
    // {
    //   examType = this.tenant=='srichaitanya' ? "SCTS_new_pattern": "ILTS_new_pattern"; 
    // }
    // else if(examType == 'SCHOLARSHIPTEST')
    // {
    //   examType = this.tenant=='srichaitanya' ? "SCTS_new_pattern": "ILTS_new_pattern"; 
    // }
    else {
      examType = "PYP"
    } 
    this.gaService.sendEvent(
      `begin_test_${examType}`, 
      examInfo.examtype, 
      'begin_test', 
      'beginning', 
    );
    this.testBegins.emit(true);
  }
  submitSubscriber: any;
  subscribeToSubmit(callBack: Function) {
    if(this.submitSubscriber && this.submitSubscriber.unsubscribe) {
      this.submitSubscriber.unsubscribe();
    }
    this.submitSubscriber = this.submitExamFromHeader.subscribe(callBack);
  }

  unsubscribeFromSubmit(callBack?: Function) {
    if(this.submitSubscriber && this.submitSubscriber.unsubscribe) {
      this.submitSubscriber.unsubscribe();
      this.submitSubscriber = undefined;
      if(callBack) callBack();
    }
  }
  

  triggerTestFinish(isSuccessFul: boolean): any {
    this.testFinish.emit(isSuccessFul);
  }
  triggerSubjectChange(backOrPrevOrSubButton:any): any {
    this.subjectChange.emit(backOrPrevOrSubButton);
  }
  triggerSubjectChangeSolutionPage(previousSubject:boolean): any {
    this.subjectChangeSolutionPage.emit(previousSubject);
  }
  
  showSelectedQuestion(questionNumber: any): any {
    this.showQuestionByNumber.emit(questionNumber);
  }
  showSelectedQuestionInReport(questionNumber: any): any {
    this.showReportQuestionByNumber.emit(questionNumber);
  }
  getSubjects(queryParams){
    let url = this.apiUrl+'getsubjects'
    let headers = {
      'accesstoken': localStorage.getItem('token'),
     
    };
    return this.getWithHeadersAndParams<any>(url,headers, queryParams);
  }
  //Get Subject Exam wise
  getSubjectsForExam(userId: any, examId: any){
    let url = this.cmsapiUrl + `examtoc/v2/getSubjectsForExam/${examId}?status=active&subtenantIds=${JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))?.subTenant?.toString()}&tenantIds=${JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))?.tenantId?.toString()}`;
    let headers = {
      'accesstoken': localStorage.getItem('token'),
       'userId': userId + ""
    };
    return this.getWithHeaders<any>(url,headers);
  }
  reportError(body:any){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
    }
    return this._httpClient.post(this.apiUrl+'reports/error/',body,{headers:headers})
  }

  getReportError(ruleid:any,studentid:any,questionid:any,phoneNumber:any){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
    }
    let body= {
        "ruleid":ruleid,
        "studentid":studentid,
        "questionid": questionid,
        "phone": phoneNumber
      
    }
    // return this._httpClient.post(this.apiUrl+'exam/getQuestionReportedData/',body,{headers:headers});
    return this._httpClient.post(this.apiUrl+'reports/question/error',body,{headers:headers});
  }


  getRuleDetails(ruleId:any){
    let body={
      "ruleid":ruleId
    }
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this._httpClient.post(this.apiUrl+'exam/rules/details',body,{headers:headers});
  }
  updatefeedback(body){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this._httpClient.post<any>(this.apiUrl+'updatefeedback',body,{headers:headers})
    
  }
  autoSubmitTest(data){
    return new Promise((resolve,reject)=>{
    
    const postdata = {
      scheduleid: data.scheduleid,
      ruleid: data._id,
      createdby: data.phone,
      studentid: localStorage.getItem('studentid'),
      attempt:data?.attempt||'1'
    }
    let body = {
      scheduleid: data.scheduleid,
      ruleid:  data._id,
      studentid: localStorage.getItem('studentid'),
      attempt:data?.attempt||'1'
    };
    
    const observable = forkJoin({
      examquestionsV2:  this.postNode('exam/questions', postdata),
      getUserResponseData:this.testlistService.getUserTestResponseData(body)
       
    });
    observable.subscribe((combinedResponse) => {
      
      var finalQueResponse = combinedResponse?.examquestionsV2?.questions?.subjects.map((element) => {
        console.log('element: ', element);
        return {
          "subjectname": element?.subjectname,
          "subjectid":String(element?.subject),
          "responses": element?.questions?.map((que) => {
            let queresponse: any = {
              "chapter": que?.chapter,
              "questionid": que?.questionid
            }
            let checkUserAttemptedQuestion = combinedResponse?.getUserResponseData?.find(ur => ur.questionid == que?.questionid)
            if (checkUserAttemptedQuestion ) {
              queresponse = {
                ...queresponse,
                "visitedtime": checkUserAttemptedQuestion?.timeSpentOnQuestion,
                "isvisited": checkUserAttemptedQuestion.questionStatus != 'notVisited' ? true: false,
                "ismarkedforreview": (checkUserAttemptedQuestion?.questionStatus == 'answeredMarkReview' || checkUserAttemptedQuestion?.questionStatus == 'notAnsweredMarkReview') ? true :false,
                "answer_given":  checkUserAttemptedQuestion.questionStatus == 'notAnswered' || checkUserAttemptedQuestion.questionStatus == 'notAnsweredMarkReview' ? false : true ,
              }
              let questionType = String(que.questiontype?.questiontype) == "3f82eed7-9e45-404c-be19-f0a98cfcba3b" ? questionTypes[que.questiontype?.childquestiontype] || "MCQ" : questionTypes[que.questiontype?.questiontype] || "MCQ";
             if ( questionType == 'Numeric') {//numeric starts
                queresponse.selectedanswer = checkUserAttemptedQuestion?.questionResponse!=='null' ? [checkUserAttemptedQuestion?.questionResponse]:[];
                let decPointPos = que.questionanswer.indexOf('.'),ansIsInt,newAns,selectedChoice = checkUserAttemptedQuestion?.questionResponse;
                let ansCopy = que.questionanswer;
                if (decPointPos < 0) {
                  ansIsInt = true;
                  decPointPos = que.questionanswer.length - 1;
                  newAns = Array.isArray(ansCopy) ? ansCopy[0].substring(0, decPointPos + 1) : ansCopy.substring(0, decPointPos + 1);
                } else {
                  newAns = Array.isArray(ansCopy) ? ansCopy[0].substring(0, decPointPos) : ansCopy.substring(0, decPointPos);
                }
                for (let i = decPointPos + 1; i < decPointPos + 3; i++) {
                  if (ansCopy[i] != null) {
                    newAns += ansCopy[i];
                  } else {
                    newAns += '0';
                  }
                }
                newAns += '00';
                newAns = parseInt(newAns);
                decPointPos = selectedChoice.indexOf('.');
                ansCopy = selectedChoice;
                let newUserAns;
                if (decPointPos < 0) {
                  decPointPos = selectedChoice.length - 1;
                  newUserAns = Array.isArray(ansCopy) ? ansCopy[0].substring(0, decPointPos + 1) : ansCopy.substring(0, decPointPos + 1);
                } else {
                  newUserAns = Array.isArray(ansCopy) ? ansCopy[0].substring(0, decPointPos) : ansCopy.substring(0, decPointPos);
                }
                for (let i = decPointPos + 1; i < decPointPos + 5; i++) {
                  if (ansCopy[i] != null) {
                    newUserAns += ansCopy[i];
                  } else {
                    newUserAns += '0';
                  }
                }
                newUserAns = parseInt(newUserAns);
                if (newAns % 10000 == 0) {
                  if (newAns == newUserAns) {
                    queresponse.iscorrectanswer = 'Y';
                  } else {
                    queresponse.iscorrectanswer = 'N';
                  }
                } else {
                  const approxAnsI1 = newAns - 100;
                  const approxAnsI2 = newAns + 100;
                  if (
                    newUserAns >= approxAnsI1 &&
                    newUserAns <= approxAnsI2
                  ) {
                    queresponse.iscorrectanswer = 'Y';
                  } else {
                    queresponse.iscorrectanswer = 'N';
                  }
                }
                if (queresponse.iscorrectanswer == 'Y') {
                  queresponse.marks = parseInt(que.totalmarks);
                }
              }//numeric Ends
              else if(questionType == 'MCQ'){ //for now assuming mmcq 
                queresponse.selectedanswer = checkUserAttemptedQuestion?.questionResponse!=='null' ? [checkUserAttemptedQuestion?.questionResponse]:[];
                queresponse.marks = checkUserAttemptedQuestion?.questionResponse == que?.questionanswer ? +que?.totalmarks : +que?.negativemarks
                queresponse.iscorrectanswer= checkUserAttemptedQuestion?.questionResponse == que?.questionanswer ? "Y" : "N";                
              }//assuming mmcq ends
            } 
            return queresponse;
          })
        }
      })
   var submit_test_body :any=   {
        "scheduleid": data.scheduleid,
        "studentid": data.phone,
        "phone": data.phone,
        "ruleid":  data._id,
        "questionanswer":  finalQueResponse,
        "coursetype": data.coursetype,
        "examtype": data.examtype,
        "status": "MANUAL_CONSTRUCT",
        "testreview": {
            "testtype": "",
            "difficultylevel": [
                ""
            ],
            "feedback": "",
            "experience": ""
        },
        "examsubmittedon": "",
        "studentClass":  data?.grade,
        subscription: {
          module: this.testlistService?.getUSerExamlist?.packageKey,
          id:this.testlistService?.getUSerExamlist?.packageId ?? 0
        },
        // "subscription": {
        //     "module": "assessment",
        //     "id":  this.testlistService.currentActivePackage(data.examtype)?.subscription_id||0
        // },
        "TestType": data?.testtype,
        "source":data?.source||'',
        "attempt":data?.attempt||'1'
      }
      this.classService.getClasses( {
        type: 'recommended',
        page: 1,
        limit: 1,
        customFilter: ''
      }).subscribe((res: any) => {
        if (res && res.statusCode == 200) {
          let _headers = {
            'accesstoken': localStorage.getItem('token'),
            'studentid': localStorage.getItem('studentid'),
            'methodtype': 'SUBMITRESULT',
            'Content-Type': 'application/json'
          };
          localStorage.setItem('serverTime', res.data.utcTime);
         submit_test_body.examsubmittedon = new Date( Number(res.data.utcTime+'000'))
          this.submitExam(submit_test_body, _headers).subscribe(result => {
            resolve(true)
          },()=>{
            reject(false)
          })
        }
        })
    })
      
    });
  }
  store_max_limit_webstorage(key,value){
    try{
      this.storage.store(key, value);
    }catch{
      console.log('fails')
      this.heavy_storage_reponse[key] = value
    }
  }
  get_max_limit_webstorage(key){
     if(this.heavy_storage_reponse[key]){
      return this.heavy_storage_reponse[key]
     }else {
      return this.storage.retrieve(key)
     }
  }
  downloadScoreTestCertificate(param){
  return  this._httpClient.get(this.apiUrl+'score/downloadScoreTestCertificate',{params:param})
  }

  getVideoData(videoId : string,userId : string){
    return this._httpClient.get(`${this.cmsapiUrl}videos/get_video/${videoId}`,{headers : {userid : userId}})
  }
  checkIsSubjectConsidate(){
    let examInfo = this.getPresentExamInfo()
    const isNeet = filterCMSData()?.[0]?.CMS_Exam_Name ==  "NEET"? true :false;
  // return ['51592ef8-8334-479f-8a91-7cfe809b7c04', '5d6fcff0-1000-45bb-b62a-d3d2b2bd3189'].some(v => v == examInfo?.test_type)
      return isNeet && examInfo?.consolidateSubject;
  }
}

function setSubjectName(questions: any, subname: string, subjectNameWithGrade: any): any {
  questions && questions.length> 0 && questions.forEach((ques: any) => {
    ques.subjectname = subname;
    ques.subgradeName = subjectNameWithGrade;
  })

  return questions;
}
